var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import isEqual from 'lodash/isEqual';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import * as Sentry from '@sentry/browser';
import api from '../services/api';
import { withNurseryContext } from '../contexts/NurseryContext';
import PdpHeader from '../components/PlantDetail/pdpHeader';
import PdpNav from '../components/PlantDetail/pdpNav';
import PdpFacts from '../components/PlantDetail/pdpFacts';
import PdpSubmission from '../components/PlantDetail/pdpSubmission';
import PdpRelated from '../components/PlantDetail/pdpRelated';
import PdpDetails from '../components/PlantDetail/pdpDetails';
var DetailLayout = /** @class */ (function (_super) {
    __extends(DetailLayout, _super);
    function DetailLayout(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.headerValue = typeof window !== 'undefined' && ((_a = window.document.head.querySelector('meta[name="x-app-type"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content'));
        _this.isSSR = _this.headerValue === 'SSR';
        _this.syncNurseryFromLocation = function (locationSearch) {
            var _a = _this.props, setNurserySlug = _a.setNurserySlug, setNurseryName = _a.setNurseryName;
            var search = locationSearch || window.location.search || '';
            var querySearch = search.startsWith('?') ? search.substring(1) : search;
            var parsed = querySearch ? queryString.parse(querySearch) : {};
            var querySlug = typeof parsed.nurseries === 'string' ? parsed.nurseries : '';
            if (querySlug) {
                setNurserySlug(querySlug);
            }
            else {
                setNurserySlug('');
                setNurseryName('');
            }
            return querySlug;
        };
        _this.setPDPData = function (plantId, plantName, slugOverride) {
            var _a = _this.props, setNavigationData = _a.setNavigationData, setNurseryName = _a.setNurseryName, setNurserySlug = _a.setNurserySlug, nurserySlug = _a.nurserySlug;
            var effectiveSlug = slugOverride !== undefined ? slugOverride : (nurserySlug || '');
            _this.pendingSlug = effectiveSlug || undefined;
            var slugParam = effectiveSlug ? "?nursery=".concat(effectiveSlug) : '';
            api.plant.getPlants("".concat(plantId, "/").concat(plantName, "/").concat(slugParam)).then(function (plantData) {
                _this.pendingSlug = undefined;
                if (effectiveSlug && plantData.nursery_name) {
                    setNurseryName(plantData.nursery_name);
                }
                else {
                    setNurseryName('');
                    setNurserySlug('');
                }
                if (effectiveSlug) {
                    setNavigationData(plantData.nursery_navigation);
                }
                else
                    setNavigationData(null);
                _this.setState({ plantData: plantData });
            }).catch(function (err) {
                _this.pendingSlug = undefined;
                if (err !== 'Request aborted') {
                    Sentry.captureException(err);
                }
            });
        };
        _this.state = {
            plantData: _this.isSSR || typeof window === 'undefined' ? props.plantApiData : {
                alias: [],
                description: '',
                django_pk: 0,
                genus: '',
                get_plant_types: [],
                is_for_sale: false,
                plant_attr: [
                    {
                        attr_name: '',
                        attr_type: '',
                        attr_values: [
                            {
                                attr_pk_value: 0,
                                attr_value: '',
                            },
                        ],
                        pk_value: 0,
                    },
                ],
                plant_size: {
                    height: '',
                    width: '',
                },
                scientific_name: '',
                shopify_handle: '',
                shopify_product_id: 0,
                shopify_variants: [
                    {
                        available: false,
                        fulfillment_service: '',
                        handle: '',
                        id: '',
                        nursery: {
                            name: '',
                            shipping_info: '',
                        },
                        price: 0,
                        title: '',
                    },
                ],
                editorial_description: null,
                plantlust_description: {
                    contributor_info: {
                        avatar: '',
                        email: '',
                        is_nursery: false,
                        active: false,
                        location: {
                            address_line1: '',
                            address_line2: '',
                            city: '',
                            state: '',
                        },
                        name: '',
                        phone: '',
                        services: [],
                        slug: '',
                        url: '',
                    },
                    description_text: '',
                    is_photo: false,
                },
                submissions_descriptions: [
                    {
                        contributor_info: {
                            avatar: '',
                            email: '',
                            is_nursery: false,
                            active: false,
                            location: {
                                address_line1: '',
                                address_line2: '',
                                city: '',
                                state: '',
                            },
                            name: '',
                            phone: '',
                            services: [],
                            slug: '',
                            url: '',
                        },
                        description_text: '',
                        is_photo: false,
                        photo: '',
                        photo_id: -1,
                        source_host: '',
                        source_url: '',
                        tags: [],
                        websites: [],
                    },
                ],
                submissions_photos: [
                    {
                        contributor_info: {
                            avatar: '',
                            email: '',
                            is_nursery: false,
                            active: false,
                            location: {
                                address_line1: '',
                                address_line2: '',
                                city: '',
                                state: '',
                            },
                            name: '',
                            phone: '',
                            services: [],
                            slug: '',
                            url: '',
                        },
                        copyright_info: '',
                        is_photo: false,
                        photo: '',
                        photo_id: 0,
                        source_host: '',
                        source_url: '',
                        tags: [],
                        url: '',
                        alt: '',
                        websites: [],
                    },
                ],
                tags: [{
                        name: '',
                        slug: '',
                        url: '',
                    }],
                title: '',
                url: '',
                zones: [],
                nurseries: [
                    {
                        address: '',
                        description: '',
                        email: '',
                        name: '',
                        phone: '',
                        services: [],
                        slug: '',
                        url: '',
                        shop_url: '',
                    },
                ],
                related: {
                    genus: {
                        name: '',
                        slug: '',
                        url: '',
                    },
                    plant_count: 0,
                    plant_list: [
                        {
                            aka_names: [],
                            dimensions: {
                                H: '',
                                W: '',
                            },
                            django_pk: 0,
                            is_for_sale: false,
                            photo: '',
                            photo_webp: '',
                            photo_description: '',
                            plant_type: '',
                            primary_name: '',
                            slug: '',
                            sun_exposure: [],
                            variants: [],
                            water_needs: [],
                            zones_str: '',
                        },
                    ],
                },
                affiliated_links: [],
            },
        };
        return _this;
    }
    DetailLayout.prototype.componentDidMount = function () {
        var _a = this.props, match = _a.match, setNurseryName = _a.setNurseryName;
        var _b = match.params, plantId = _b.plantId, plantName = _b.plantName;
        var plantData = this.state.plantData;
        var querySlug = this.syncNurseryFromLocation();
        if (plantData === null || plantData === void 0 ? void 0 : plantData.nursery_name) {
            setNurseryName(plantData.nursery_name);
        }
        if (!(this.isSSR && (plantData === null || plantData === void 0 ? void 0 : plantData.django_pk))) {
            this.setPDPData(plantId, plantName, querySlug);
        }
    };
    DetailLayout.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (isEqual(this.state, nextState)
            && isEqual(this.props, nextProps)) {
            return false;
        }
        return true;
    };
    DetailLayout.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, nurserySlug = _a.nurserySlug, match = _a.match, location = _a.location;
        var plantData = this.state.plantData;
        var locationChanged = !isEqual(prevProps.location, location);
        if (locationChanged) {
            var _b = match.params, plantId = _b.plantId, plantName = _b.plantName;
            var querySlug = this.syncNurseryFromLocation(location.search);
            this.setPDPData(plantId, plantName, querySlug);
            return;
        }
        if (!(plantData === null || plantData === void 0 ? void 0 : plantData.nursery_name)
            && nurserySlug
            && prevProps.nurserySlug !== nurserySlug
            && this.pendingSlug !== nurserySlug) {
            var _c = match.params, plantId = _c.plantId, plantName = _c.plantName;
            this.setPDPData(plantId, plantName, nurserySlug);
        }
    };
    DetailLayout.prototype.render = function () {
        var addToShopifyCart = this.props.addToShopifyCart;
        var plantData = this.state.plantData;
        var shopifyVariants = plantData.shopify_variants, shopifyHandle = plantData.shopify_handle, title = plantData.title, alias = plantData.alias, scientificName = plantData.scientific_name, isForSale = plantData.is_for_sale, affiliatedLinks = plantData.affiliated_links, partnersData = plantData.nurseries, djangoPk = plantData.django_pk, plantlustDescription = plantData.plantlust_description, editorialDescription = plantData.editorial_description, photos = plantData.submissions_photos, relatedData = plantData.related;
        var hasPhotos = photos.length > 0;
        return (React.createElement("div", { className: "pdp_container" },
            React.createElement("div", { className: "fullwidth_pdp_header" },
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "pdp_header__container" },
                        React.createElement(PdpHeader, { djangoPk: djangoPk, shopifyVariants: shopifyVariants, shopifyHandle: shopifyHandle, addToShopifyCart: addToShopifyCart, title: title, plantlustDescription: plantlustDescription, editorialDescription: editorialDescription, alias: alias, scientificName: scientificName, photos: photos, isForSale: isForSale, plantData: plantData, partnersData: partnersData, affiliatedLinks: affiliatedLinks }),
                        React.createElement(PdpDetails, { plantData: plantData }),
                        React.createElement("div", null,
                            React.createElement(PdpNav, { hasPhotos: hasPhotos, hasMoreTypes: relatedData.plant_list.length > 0 }))))),
            React.createElement("div", { className: "fullwidth_pdp_submissions", id: "photo-gallery" },
                React.createElement("div", { className: "container" },
                    React.createElement(PdpSubmission, { data: photos, title: title }))),
            React.createElement("div", { className: "fullwidth_pdp_details", id: "plant-facts" },
                React.createElement("div", { className: "container" },
                    React.createElement(PdpFacts, { plantData: plantData }))),
            React.createElement("div", { className: "fullwidth_pdp_related", id: "more-types" },
                React.createElement("div", { className: "container" },
                    React.createElement(PdpRelated, { data: relatedData, addToShopifyCart: addToShopifyCart })))));
    };
    return DetailLayout;
}(React.Component));
export default withRouter(withNurseryContext(DetailLayout));
